var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 51,
    viewBox: "0 0 59 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.539062 42.9C0.539062 43.4148 0.795797 43.8954 1.22353 44.1816L10.0826 50.1098V12.8423L29.5674 24.9642L49.0523 12.8423V50.1098L57.9113 44.1816C58.3391 43.8954 58.5958 43.4148 58.5958 42.9V7.0648C58.5958 6.53023 58.3189 6.03379 57.8641 5.75286L49.0543 0.311155C48.5644 0.00855415 47.9468 0.00410847 47.4526 0.299625L31.3238 9.94416C30.2422 10.5909 28.8926 10.5909 27.811 9.94416L11.6823 0.299625C11.1881 0.00410692 10.5704 0.00855263 10.0806 0.311154L1.27073 5.75286C0.81592 6.03379 0.539062 6.53023 0.539062 7.0648V42.9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0312 44.4486C18.0312 44.9894 17.7479 45.4907 17.2847 45.7697L10.0781 50.1098V12.8423L29.5629 24.9642L49.0478 12.8423V50.1098L41.7502 44.9825C41.3393 44.6937 41.0947 44.2229 41.0947 43.7206V29.3547L29.5629 36.539L18.0312 29.3547V44.4486Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintair);
export default __webpack_public_path__ + "static/media/mintair.967e8a54967d011efe75b652279534e5.svg";
export { ForwardRef as ReactComponent };